export default [
  {
    title: 'Suites & Lots',
    route: 'products-suites-index',
    icon: 'dashboard.svg',
    customIcon: true,
    resource: 'Suite',
    action: 'read',
    parent: 'products',
  },
  {
    title: 'Locations',
    route: 'products-locations-index',
    icon: 'MapPinIcon',
    resource: 'SuiteLocation',
    action: 'read',
    parent: 'products',
  },
  {
    title: 'Areas',
    route: 'products-areas-index',
    icon: 'MapIcon',
    resource: 'SuiteArea',
    action: 'read',
    parent: 'products',
  },
  // {
  //   title: 'Promotions and Discounts',
  //   route: 'products-promotions-index',
  //   icon: 'DiscIcon',
  //   resource: 'Promotion',
  //   action: 'read',
  //   parent: 'products',
  // },
  {
    header: 'Products',
    icon: 'urn.svg',
    customIcon: true,
    parent: 'products',
    children: [
      {
        title: 'Product Catalog',
        route: 'products-catalog-index',
        icon: '',
        resource: 'ProductCatalog',
        action: 'read',
      },
      {
        title: 'Product Categories',
        route: 'products-categories-index',
        icon: '',
        resource: 'ProductCategory',
        action: 'read',
      },
      {
        title: 'Product Codes',
        route: 'products-codes-index',
        icon: '',
        resource: 'ProductCode',
        action: 'read',
      },
    ],
  },
  // {
  //   title: 'Entitlement Schemes',
  //   route: 'products-schemes-index',
  //   params: {
  //     type: 'all-scheme',
  //   },
  //   icon: 'PaperclipIcon',
  //   resource: 'EntitlementScheme',
  //   action: 'read',
  //   parent: 'products',
  // },
]
